import { useTranslation } from "react-i18next"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectSeparator,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { useUseCasesStore } from "@/stores/use-cases-store"

import { useUseCases } from "../../hooks/use-use-cases"

type UseCaseSelectorProps = {
  onNewUseCase?: () => void
}

export function UseCaseSelector({ onNewUseCase }: UseCaseSelectorProps) {
  const { t } = useTranslation()
  const { data: useCases } = useUseCases()
  const { selectedUseCaseId, setSelectedUseCaseId } = useUseCasesStore()

  const handleValueChange = (v: string) => {
    if (v === "__new__" && onNewUseCase) {
      onNewUseCase()
      return
    }
    setSelectedUseCaseId(v === "__new__" ? null : v)
  }

  return (
    <div className="mb-4">
      <Select value={selectedUseCaseId ?? "__new__"} onValueChange={handleValueChange}>
        <SelectTrigger className="w-72">
          <SelectValue placeholder={t("useCases.factSheet.selectUseCase")} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="__new__">{t("useCases.factSheet.newUseCase")}</SelectItem>
          {useCases && useCases.length > 0 && (
            <>
              <SelectSeparator />
              {useCases.map((uc) => (
                <SelectItem key={uc.id} value={uc.id}>
                  <span className="flex items-center gap-1.5">
                    {uc.ucName || uc.id}
                    {uc.hasUnviewedNotification && (
                      <span className="border-foreground bg-primary inline-block size-2 rounded-full border" />
                    )}
                  </span>
                </SelectItem>
              ))}
            </>
          )}
        </SelectContent>
      </Select>
    </div>
  )
}
